export default __webpack_public_path__ + "static/media/wallet-connect.e9313e09.svg";